import React, { FC } from 'react';
import classNames from 'classnames';
import styles from './TotalReturnStatement.module.scss';

type Props = {
  className?: string;
};

const TotalReturnStatement: FC<Props> = ({ className }) => (
  <div className={classNames(styles['legal-disclaimer'], className)}>
    Total return includes all realized and unrealized gains and losses plus
    income. Performance figures are shown gross of advisory fees. Total returns
    would be lower as a result of the deduction of such fees.
  </div>
);

export default TotalReturnStatement;
